import React from "react";
import { WHY_US } from "@/site.config";

export default function WhyUs() {
  return (
    <section
      id="pourquoi"
      data-testid="why-us-section"
      className="relative py-24 sm:py-32 px-5 sm:px-8"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#9DEB30] mb-3">
              · Pourquoi nous choisir
            </div>
            <h2
              data-testid="why-us-title"
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight max-w-2xl"
            >
              Une exécution rigoureuse,{" "}
              <span className="text-[#9DEB30]">une vision moderne.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-base">
            SIGNA CLEAN combine expertise terrain BTP et innovation
            technologique pour livrer des interventions propres, sûres et durables.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {WHY_US.map((item, i) => {
            const Icon = item.icon;
            const featured = i === 0;
            return (
              <div
                key={i}
                data-testid={`why-card-${i}`}
                className={`neon-border rounded-2xl p-7 bg-[#101010] ${
                  featured ? "lg:col-span-2 lg:row-span-1" : ""
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className="h-11 w-11 rounded-xl flex items-center justify-center bg-[#9DEB30]/10 border border-[#9DEB30]/30 text-[#9DEB30]">
                    <Icon size={20} />
                  </div>
                  <span className="text-xs font-mono text-zinc-500">0{i + 1}</span>
                </div>
                <h3 className="font-display mt-5 text-xl sm:text-2xl font-bold">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
